import axios, { AxiosResponse } from "axios";
import api, { ApiResponse } from "./api";

const API_URL = "v1/media/";

class MediaService {
    async generate(uid: number, extensions: string[]) {
        const response = await api
            .post(API_URL + "url/generate", {
                uid,
                extensions
            })
            .then((response: ApiResponse) => {
                return response.data;
            });
        
        return response;
    }

    async upload(urls: string[], mediaData: any) {
        let axiosArray: Promise<AxiosResponse<any, any>>[] = [];
        urls.forEach((url, index) => {
            axiosArray.push(axios({
                method: 'put',
                headers: { 'Content-Type': 'multipart/form-data' },
                url: url,
                data: mediaData[index]
            }));
        });
        const response = await axios
            .all(axiosArray)
            .then(axios.spread((...responses) => {
                return responses.every((response) => response.status === 200);
            }))

        return response;
    }

    async verify(id: number, mediaFileNames: string[]) {
        const response = await api
            .post(API_URL + "upload/verify", {
                id,
                mediaFileNames
            })
            .then((response: ApiResponse) => response.data);

        return response;
    }
}

const mediaService = new MediaService();

export default mediaService;
